 //Infobip api data
//Required parameters:
//Email
//GDPR consent permission
//Country
//Language
//Brand
//Opt-in date
//Creation date

export function InfobipApiData(
    firstName,
    lastName,
    address,
    city,
    country,
    gender,
    Username,
    Postcode,
    Language,
    Campaignname,
    Brand,
    Lastinteractiontype,
    Interest,
    Optindate,
    Creationdate,
    Lastinteractiondate,
    GDPRconsentpermission,
    WAconsent,
    Viberconsent,
    SMSconsent,
    Emailconsent,
    argeta_junior,
    argeta_veggie,
    argeta_core,
    argeta_exclusive,
    email,
    phone,
) {
    var infobipData = {};
    //Data
    if(firstName) {
        infobipData['firstName'] = firstName;
    }
    if(lastName) {
        infobipData['lastName'] = lastName;
    }
    if(address) {
        infobipData['address'] = address;
    }
    if(city) {
        infobipData['city'] = city;
    }
    if(country) {
        infobipData['country'] = country;
    }
    if(gender) {
        infobipData['gender'] = gender;
    }
    //Custom attributes
    infobipData['customAttributes'] = {};
    if(Username) {
        infobipData['customAttributes']['Username'] = Username;
    }
    if(Postcode) {
        infobipData['customAttributes']['Post code'] = Postcode;
    }
    if(Language) {
        infobipData['customAttributes']['Language'] = Language;
    }
    if(Campaignname) {
        infobipData['customAttributes']['Campaign name'] = Campaignname;
    }
    if(Brand) {
        infobipData['customAttributes']['Brand'] = Brand;
    }
    if(Lastinteractiontype) {
        infobipData['customAttributes']['Last interaction type'] = Lastinteractiontype;
    }
    if(Interest) {
        infobipData['customAttributes']['Interest'] = Interest;
    }
    if(Optindate) {
        infobipData['customAttributes']['Opt-in date'] = Optindate;
    }
    if(Creationdate) {
        infobipData['customAttributes']['Creation date'] = Creationdate;
    }
    if(Lastinteractiondate) {
        infobipData['customAttributes']['Last interaction date'] = Lastinteractiondate;
    }
    if(GDPRconsentpermission) {
        infobipData['customAttributes']['GDPR consent permission'] = GDPRconsentpermission;
    } else {
        infobipData['customAttributes']['GDPR consent permission'] = false;
    }
    if(WAconsent) {
        infobipData['customAttributes']['WA consent'] = WAconsent;
    } else {
        infobipData['customAttributes']['WA consent'] = false;
    }
    if(Viberconsent) {
        infobipData['customAttributes']['Viber consent'] = Viberconsent;
    } else {
        infobipData['customAttributes']['Viber consent'] = false;
    }
    if(SMSconsent) {
        infobipData['customAttributes']['SMS consent'] = SMSconsent;
    } else {
        infobipData['customAttributes']['SMS consent'] = false;
    }
    if(Emailconsent) {
        infobipData['customAttributes']['Email consent'] = Emailconsent;
    } else {
        infobipData['customAttributes']['Email consent'] = false;
    }
    if(argeta_junior) {
        infobipData['customAttributes']['argeta_junior'] = argeta_junior;
    } else {
        infobipData['customAttributes']['argeta_junior'] = false;
    }
    if(argeta_veggie) {
        infobipData['customAttributes']['argeta_veggie'] = argeta_veggie;
    } else {
        infobipData['customAttributes']['argeta_veggie'] = false;
    }
    if(argeta_core) {
        infobipData['customAttributes']['argeta_core'] = argeta_core;
    } else {
        infobipData['customAttributes']['argeta_core'] = false;
    }
    if(argeta_exclusive) {
        infobipData['customAttributes']['argeta_exclusive'] = argeta_exclusive;
    } else {
        infobipData['customAttributes']['argeta_exclusive'] = false;
    }
    //contactInformation
    infobipData['contactInformation'] = {};
    infobipData['contactInformation']['email'] = [
        {
            "address": email
        }
    ];
    if (phone) {
        infobipData['contactInformation']['phone'] = [
            {
                "number": phone
            }
        ];
    }

    return infobipData;
}



//Infobip api call
export function InfobipApiCall(dataInfobip) {

    var ajaxFormData = {};
    ajaxFormData['action'] =  "infobip_form";
    ajaxFormData['id'] =  "1";
    ajaxFormData['apiData'] = dataInfobip;

    console.log("Form Data: ", ajaxFormData);

    $.ajax({
        type : "post",
        dataType : "json",
        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
        data : ajaxFormData,
        success: function(response) {
            console.log("Ajax infobip success", response);
        },
        error: function (error) {
            console.log(error);
            console.log("Ajax infobip error", (error));
        }
    });

    return dataInfobip;
}
